module.exports = __webpack_public_path__ + "img/2.08.a175fb7b.jpg";